import { Carousel, Title } from "@bookingcom/bui-react";
import { UIFlightData } from "@flights/types";
import React from "react";
import useAlternativeFaresCarouselController from "./useAlternativeFaresCarousel.controller";
import { SkeletonFlightCard } from "../Skeleton/SkeletonFlightCard";
import FlightCard from "../FlightCard/FlightCard";

type Props = {
  flights?: UIFlightData[];
  loading?: boolean;
  /* start - flights_alternative_fares_for_price_change_and_sold_out_errors_web */
  viewFlightDetailsCtaLabel?: string;
  disabled?: boolean;
  /* end - flights_alternative_fares_for_price_change_and_sold_out_errors_web */
  onActionClick: () => void;
  onFareClick: (fare: UIFlightData, index: number) => void;
};

const AlternativeFaresCarousel = ({
  flights,
  loading,
  viewFlightDetailsCtaLabel,
  disabled = false,
  onActionClick,
  onFareClick
}: Props) => {
  const {
    carouselSize,
    carouselActionCta,
    nextButtonAriaLabel,
    previousButtonAriaLabel,
    title,
    subtitle,
    forceHideLastAvailableSeats
  } = useAlternativeFaresCarouselController();

  return (
    <div>
      <Carousel
        size={carouselSize}
        action={{
          text: carouselActionCta,
          iconPosition: "start",
          type: "button",
          size: "large",
          onClick: onActionClick,
          disabled
        }}
        nextButtonAriaLabel={nextButtonAriaLabel}
        previousButtonAriaLabel={previousButtonAriaLabel}
        title={<Title title={title} variant="headline_3" tagName="h2" subtitle={subtitle} />}
      >
        {loading
          ? Array.from({ length: 4 }).map((_, i) => <SkeletonFlightCard key={i} />)
          : flights?.map((fare, idx) => {
              return (
                <FlightCard
                  flight={fare}
                  onClick={() => onFareClick(fare, idx)}
                  index={idx}
                  isAlternativeFareCard={true}
                  forceHideLastAvailableSeats={forceHideLastAvailableSeats}
                  key={fare.token}
                  viewFlightDetailsCtaLabel={viewFlightDetailsCtaLabel}
                  disabled={disabled}
                />
              );
            })}
      </Carousel>
    </div>
  );
};

export default AlternativeFaresCarousel;
